export default class Notify {
  constructor(options = {}) {
    const defaultOptions = {
      title: 'Новое сообщение в чате на GB.RU',
      icon: 'https://gb.ru/android-chrome-192x192.png',
      sound: 'https://frontend-scripts.hb.bizmrg.com/sounds/message.mp3'
    }
    this.options = { ...defaultOptions, ...options }
    this.sound = new Audio(this.options.sound)
  }

  requestPermission() {
    return Notification.requestPermission()
  }

  async spawnNotification(body, avatar) {
    if (Notification.permission === 'granted') {
      // eslint-disable-next-line no-new
      new Notification(this.options.title, { body, icon: avatar || this.options.icon })
      try {
        await this.sound.play()
      } catch (e) {
        console.error(e.message)
      }
    }
  }
}
